var _circle, _path, _path2, _path3, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemorqeur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#5F99FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11H3L4.17895 15H15C17.2091 15 19 13.2091 19 11V11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33331 8.33333C4.33331 7.59695 4.93027 7 5.66665 7H9.66665C10.403 7 11 7.59695 11 8.33333V11H4.33331V8.33333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9333 9.6665H20.3333V9.6665C20.3333 10.4029 19.7364 10.9998 19 10.9998H12.3333L13.9333 9.6665Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.33335,
    cy: 9.00016,
    r: 0.666667,
    fill: "#5F99FE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99998,
    cy: 9.00016,
    r: 0.666667,
    fill: "#5F99FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemorqeur);
export default __webpack_public_path__ + "static/media/remorqeur.e85580db984308beef55fe773b8b2bea.svg";
export { ForwardRef as ReactComponent };